/**
 * /!\ This file is auto-generated.
 *
 * This is the entry point of your standalone application.
 *
 * There are multiple tags used by the editor to inject code automatically:
 *     - `wle:auto-constants:start` and `wle:auto-constants:end`: The project's constants,
 *        such as the project's name, whether it should use the physx runtime, etc...
 *     - `wle:auto-benchmark:start` and `wle:auto-benchmark:end`: Append the benchmarking code
 */

import {loadRuntime} from '@wonderlandengine/api';

/* wle:auto-constants:start */
const Constants = {
    ProjectName: 'Arena Wars',
    RuntimeBaseName: 'WonderlandRuntime',
    WebXRRequiredFeatures: ['local',],
    WebXROptionalFeatures: ['local','hit-test',],
};
const RuntimeOptions = {
    webgl2: true,
    webgpu: false,
    physx: true,
    loader: false,
    xrFramebufferScaleFactor: 1,
    loadUncompressedImagesAsBitmap: true,
    xrOfferSession: {
        mode: 'auto',
        features: Constants.WebXRRequiredFeatures,
        optionalFeatures: Constants.WebXROptionalFeatures,
    },
    canvas: 'canvas',
};
/* wle:auto-constants:end */

const engine = await loadRuntime(Constants.RuntimeBaseName, RuntimeOptions);
engine.onLoadingScreenEnd.once(() => {
    const el = document.getElementById('version');
    if (el) setTimeout(() => el.remove(), 2000);
});

/* WebXR setup. */

function requestSession(mode) {
    if (window.adsManager) {
        window.adsManager.triggerPreroll(() => {
            engine
                .requestXRSession(mode, Constants.WebXRRequiredFeatures, Constants.WebXROptionalFeatures)
                .catch((e) => { /* console.error(e); */ });
        });
    } else {
        engine
            .requestXRSession(mode, Constants.WebXRRequiredFeatures, Constants.WebXROptionalFeatures)
            .catch((e) => { /* console.error(e); */ });
    }
}

function setupButtonsXR() {
    /* Setup AR / VR buttons */
    const arButton = document.getElementById('ar-button');
    if (arButton) {
        arButton.setAttribute('data-supported', engine.arSupported.toString());
        arButton.addEventListener('click', () => requestSession('immersive-ar'));
    }
    const vrButton = document.getElementById('vr-button');
    if (vrButton) {
        vrButton.setAttribute('data-supported', engine.vrSupported.toString());
        vrButton.addEventListener('click', () => requestSession('immersive-vr'));
    }
}

if (document.readyState === 'loading') {
    window.addEventListener('load', setupButtonsXR);
} else {
    setupButtonsXR();
}

/* Hide desktop and VR buttons when entering XR, show them again when XR ends */
engine.onXRSessionStart.add(() => {
    const desktopBtn = document.getElementById('desktop-button');
    if (desktopBtn) desktopBtn.style.display = 'none';
    const vrBtn = document.getElementById('vr-button');
    if (vrBtn) vrBtn.style.display = 'none';
});
engine.onXRSessionEnd.add(() => {
    const desktopBtn = document.getElementById('desktop-button');
    if (desktopBtn) desktopBtn.style.display = '';
    const vrBtn = document.getElementById('vr-button');
    if (vrBtn) vrBtn.style.display = '';
});

/* Disable VR and Desktop buttons while loading the main scene */
{
    const vrBtn = document.getElementById('vr-button');
    const deskBtn = document.getElementById('desktop-button');
    if (vrBtn) { vrBtn.style.pointerEvents = 'none'; vrBtn.style.opacity = '0.3'; }
    if (deskBtn) { deskBtn.style.pointerEvents = 'none'; deskBtn.style.opacity = '0.3'; }
}

/* Load main scene */
try {
    await engine.loadMainScene(`${Constants.ProjectName}.bin`);
} catch (e) {
    // console.error(e);
    window.alert(`Failed to load ${Constants.ProjectName}.bin:`, e);
}

/* Re-enable VR and Desktop buttons after scene loads */
{
    const vrBtn = document.getElementById('vr-button');
    const deskBtn = document.getElementById('desktop-button');
    if (vrBtn) { vrBtn.style.pointerEvents = ''; vrBtn.style.opacity = ''; }
    if (deskBtn) { deskBtn.style.pointerEvents = ''; deskBtn.style.opacity = ''; }
}

/* wle:auto-benchmark:start */
/* wle:auto-benchmark:end */
